// Axios errors carry `config`/`request` (and `response.config`/`response.request`),
// which hold live functions and XHR instances that break structured-clone-based
// persistence (IndexedDB/postMessage). Drop them so ApiError instances stay
// serializable no matter what raw error is passed in.
function omitTransportInternals(source) {
  if (!source) {
    return source;
  }
  const { config, request, ...rest } = source;
  return rest;
}

class ApiError {
  constructor(message, data) {
    const { response, ...rest } = omitTransportInternals(data) ?? {};
    Object.assign(this, rest, { message });
    if (response) {
      this.response = omitTransportInternals(response);
    }
  }
}

export default ApiError;
